import { useLang } from '@/i18n';
import EFXCore3 from 'elem/ui-assets/icons/unregular/EFXCore3';
import EfSpec from 'elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');

    return (
        <div className={`${styles.TheComp} GtmModuleData-section`} data-section-id="D3-EU1" id='D3-EU1'>
            <EfSpec className="spec-x" />
            <div className="info-box na">
                <EFXCore3 className="logo" />
                <p className="desc">{t('EU1_desc')}</p>
            </div>
        </div>
    );
}
